exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button i[data-v-6fc3aec8] {\n  color: #e0e0e0;\n  font-size: 28px;\n  line-height: 24px;\n}\nbutton:hover i[data-v-6fc3aec8], button:focus i[data-v-6fc3aec8] {\n  color: #707070;\n}\n", ""]);

// exports
